import { ENTITY } from '../../lib/statusConfig';

/** @param {{entitySlug: keyof typeof ENTITY, className?: string}} props */
export function EntityChip({ entitySlug, className = '' }) {
  const cfg = ENTITY[entitySlug];
  if (!cfg) return null;
  const { Icon, label, chip } = cfg;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-chip px-2.5 py-1 text-[11px] font-semibold ${chip} ${className}`}>
      <Icon size={11} weight="fill" /> {label}
    </span>
  );
}

/** Left-border colour strip for list rows / detail, driven by entity_slug. */
export function EntitySpine({ entitySlug, className = '' }) {
  const cfg = ENTITY[entitySlug];
  return <span className={`block w-[3px] self-stretch rounded-sm ${cfg?.spine || 'bg-paper-border2'} ${className}`} />;
}

export default EntityChip;
